<template>
  <div id="red_log" :class="isFull === 1 ? 'red_log0 top_information_fixed1' : 'red_log1'">
    <!-- 顶部导航栏 -->
    <van-nav-bar
      :title="$t('column.red_envelope_record')"
      left-arrow
      fixed
      placeholder
      @click-left="goBack"
      class="custom-nav-bar"
    />

    <!-- Tab切换 -->
    <van-tabs v-model="activeTab" @change="onTabChange" class="custom-tabs" type="card">
      <van-tab :title="$t('column.gifts')" name="gifts"></van-tab>
      <van-tab :title="$t('column.received')" name="diamonds"></van-tab>
    </van-tabs>

    <!-- 列表内容 -->
    <div class="content-wrapper" v-if="listData.length > 0 || listDiamonds.length > 0">
      <div class="content-wrapper" v-if="activeTab === 'gifts'">
        <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="$t('noMore')"
        @load="onLoad"
        >
            <div
            class="list-item"
            v-for="(item, index) in listData"
            :key="index"
            >
            <div class="red-packet-item">
                <div class="red-packet-left">
                    <div class="red-packet-title">{{ item.content }}</div>
                    <div class="red-packet-tags">
                        <span class="tag-red">
                            <span class="tag-coin"><van-icon name="manager" size="12px" /></span>
                            <span class="tag-num">{{ item.people_quantity }}</span>
                        </span>
                        <span class="tag-gold">
                            <span class="tag-coin"><img src="../assets/img/coin7.png" alt=""></span>
                            <span class="tag-num">{{ item.diamonds_quantity }}</span>
                        </span>
                    </div>
                    <div class="red-packet-desc">{{ item.create_time }}</div>
                </div>
                <div class="red-packet-right">
                    <div class="receive-info" @click="goToRedOrder(item.id)">
                        <span class="receive-count">{{ $t('column.people_claimed_rewards', { number: item.receive_quantity }) }}</span>
                        <span class="receive-arrow"> <van-icon name="arrow" color="#333"/> </span>
                    </div>
                    <div class="refund-text" v-if="item.return_coin || item.status == 2">{{ $t('column.return_coin') }}:  <img src="../assets/img/coin7.png" alt=""> </img>{{ item.return_coin || 0 }}</div>
                    <div class="refund-text" v-else>
                        {{ $t('column.In_progress') }}
                      </div>
                </div>
            </div>
            <van-divider />
            </div>
        </van-list>
      </div>
      <div class="content-wrapper" v-else>
         <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="$t('noMore')"
        @load="onLoad"
        >
            <div
            class="list-item"
            v-for="(item, index) in listDiamonds"
            :key="index"
            >
            <div class="item-header" @click="goToRedOrder(item.red_id)">
                <span class="item-title">{{ item.content }}</span>
                <span class="item-amount" :class="{'positive': item.diamonds_quantity > 0}">
                {{ item.diamonds_quantity > 0 ? '+' : '' }}{{ item.diamonds_quantity }}
                </span>
            </div>
            <div class="item-time-row">
                <div class="item-time">{{ item.create_time }}</div>
            </div>
            <van-divider />
            </div>
        </van-list>
      </div>
    </div>
    <!-- 空状态 -->
    <div class="empty-wrapper" v-else>
      <div class="empty-text">{{ $t('column.no_data') }}</div>
    </div>
  </div>
</template>

<script>
import '../assets/css/style.css'
import axios from 'axios'
import Toast from "vant/lib/toast"
export default {
  name: 'RedLog',
  data() {
    return {
      activeTab: 'gifts',
      listData: [],
      listDiamonds: [],
      loading: false,
      finished: false,
      page: 1,
      pageSize: 10,
      isFull: 0
    }
  },
  created() {
    this.isFull = this.$route.query.is_full == 1 ? 1 : 0
    this.get_list()
  },
  methods: {
    goBack() {
       if (this.$route.query.source =='h5') {
            this.$router.go(-1)
        }else{
             // 拦截关闭h5
            window.location.href="bogolive://exit"
        }
    },
    goToRedOrder(id) {
      this.$router.push({
        path: '/red_order',
        query: {
          token: this.$route.query.token,
          red_packet_id: id,
          is_full: this.isFull
        }
      })
    },
    onTabChange(name) {
      this.activeTab = name
      this.listData = []
      this.listDiamonds = []
      this.page = 1
      this.finished = false
      this.get_list()
    },
    onLoad() {
      // 模拟数据加载
        if(this.page > 1){
            this.get_list();
        }
    },
    get_list(){
        let toast = false;
        if (this.page == 1) {
            toast = this.$toast.loading({
                duration: 0, // 持续展示
                forbidClick: true,
                message: this.$t('other.Loading') + '...',
                className: 'custom-loading-toast' // 添加自定义类名
            });
        }
        this.loading = true
        const token = this.$route.query.token
        const video_id = this.$route.query.video_id
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=user_h5&act=red_log_list", {
        params: {
            token:token,
            type: this.activeTab === 'gifts' ? 1 : 2,
            video_id: video_id,
            page:this.page 
        }
      }).then(res => {
          if (this.page == 1) {
            toast.clear(); // 关闭加载提示
          } 
          console.log(res.data)
          // 加载状态结束
          this.loading = false
          if (res.data.status === 0) {
              Toast(res.data.error)
              this.finished = true
              return false
          }else{
            if (this.page == 1) {
                this.listData = []
                this.listDiamonds = []
                this.finished = false
            }
            for (let i = 0; i < res.data.data.length; i++) {
                if (this.activeTab === 'gifts') {
                    this.listData.push(res.data.data[i])
                } else {
                    this.listDiamonds.push(res.data.data[i])
                }
            }
            console.log(this.listData)
            console.log(this.listDiamonds)
            // 数据全部加载完成
            if (res.data.data.length <= 0) {
                this.finished = true
            }
            this.page ++
          }
        })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/red_log.vue